import { vuexHandbook } from '@/store/composition/handbook'
import { UserPostApi } from '@/api/handbook/user/UserPost/UserPostApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: UserPostApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
